.Main {
  position: fixed;
  top: 0;
  width: 100vw;
  height: 100vh;

  canvas {
    position: absolute;
    width: 100%;
    height: 100%;
  }
}

.Node {
}
